import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { getCCAggregateOrderTable } from "src/Requests/ccOrder";
import {
  ICCOrderTableReport,
  ICCOrderAddOrderFormValues,
  ICCOrderSearchParams,
} from "src/Interfaces/ccOrder";
import { store } from "src/App/store";
import {
  setCCOrderEditRowValues,
  setCCOrderOrderFormValues,
} from "src/Features/CCOrder/ccOrderSlice";
import { Modal } from "src/Components";
import EditOrder from "src/Pages/CCOrder/EditOrder";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { CCAggregateOrderTableAdditional } from "./Additional";
import TableUI from "./TableUI";

interface IProps {
  searchParam: ICCOrderSearchParams;
}

const CCAggregateOrderTable = ({ searchParam }: IProps) => {
  const dispatch = useAppDispatch();
  const editRowValues = useAppSelector((store) => store).ccOrder
    .editOrderRowValues;

  const onTableRowClick = (row: ICCOrderTableReport) => {
    dispatch(
      setCCOrderOrderFormValues({
        ...store.getState().ccOrder.addOrderFormValues,
        coveredCallOrderBuyLegs: row?.coveredCallOrderBuyLegs,
        coveredCallOrderSellLeg: row?.coveredCallOrderSellLeg,
        coveredCallPositionStrategyEnum: row?.coveredCallPositionStrategyEnum,
        coveredCallOrderType: row?.coveredCallOrderType,
      } as ICCOrderAddOrderFormValues),
    );
  };

  return (
    <div className="overflow-auto order-table">
      {editRowValues ? (
        <Modal
          title="ویرایش سفارش"
          UI={<EditOrder isConditionId={true} />}
          onClose={() => dispatch(setCCOrderEditRowValues(null))}
        />
      ) : (
        <></>
      )}
      <TableTemplate<ICCOrderSearchParams, ICCOrderTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={getCCAggregateOrderTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <TableUI
            reports={reports}
            onAction={onAction}
            onTableRowClick={onTableRowClick}
            tableBoxClassName="max-h-[500px] overflow-auto"
            AdditionalBody={CCAggregateOrderTableAdditional}
            withSelect
            setSortingType={setSortingType}
            sortingType={sortingType}
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default CCAggregateOrderTable;
